var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-text"},[_c('p',[_vm._v("Please wait")]),_c('div',{class:{ loading: _vm.loading }})])
}
var staticRenderFns = []

export { render, staticRenderFns }